import { ThemeConfig } from 'antd'

export const antdTheme: ThemeConfig = {
  token: {},
  components: {
    Input: {
      colorBorder: '#999999',
      activeBorderColor: '#1890ff',
      hoverBorderColor: '#7a7a7a',
    },
    Select: {
      colorBorder: '#999999',
      controlOutline: 'rgba(24, 144, 255, 0.2)',
    },
    DatePicker: {
      colorBorder: '#999999',
    },
    InputNumber: {
      colorBorder: '#999999',
    },
    Checkbox: {
      colorBorder: '#999999',
    },
    Radio: {
      colorBorder: '#999999',
    },
    Switch: {
      colorBorder: '#999999',
    },
    TreeSelect: {
      colorBorder: '#999999',
    },
    Cascader: {
      colorBorder: '#999999',
    },
    Upload: {
      colorBorder: '#999999',
    },
  },
}

export default antdTheme

